export default __webpack_public_path__ + "static/char-45-72d86676c1b7e196dd25cbb9c83d9b6a.gif";